import { useEffect, useState, useReducer, useCallback } from 'react'
const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        status: 'LOADING',
        isError: false
      }
    case 'FETCH_SUCCESS':
      return {
        ...state,
        status: action.payload ? null : 'EMPTY',
        isError: false,
        data: action.payload
      }
    case 'FETCH_FAILURE':
      return {
        ...state,
        status: 'EMPTY',
        isError: action.payload
      }
    default:
      throw new Error()
  }
}

const useApiHelper = (initialHelperFunction, initialData) => {
  const [helperFunctionString] = useState(initialHelperFunction)
  const [apiFunction, setApiFunction] = useState()
  const [queryData, setQueryData] = useState()

  const [state, dispatch] = useReducer(dataFetchReducer, {
    status: 'LOADING',
    isError: false,
    data: initialData
  })

  const setApiArguments = useCallback(
    (...args) => {
      if (args.length >= 1) {
        setQueryData(args)
      } else {
        dispatch({ type: 'FETCH_FAILURE' })
      }
    },
    [setQueryData, dispatch]
  )

  useEffect(() => {
    let didCancel = false
    const setUpFunction = async () => {
      try {
        const { [helperFunctionString]: apiFunc } = await import(
          '../services/apiHelper'
        )
        if (apiFunc && !didCancel) {
          setApiFunction(() => apiFunc)
        }
      } catch (error) {
        console.error('error: ', error)
        if (!didCancel) {
          dispatch({ type: 'FETCH_FAILURE', payload: error })
        }
      }
    }
    setUpFunction()

    return () => {
      didCancel = true
    }
  }, [helperFunctionString])

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      dispatch({ type: 'FETCH_INIT' })
      try {
        const response = await apiFunction(...queryData)
        if (response && !didCancel) {
          dispatch({ type: 'FETCH_SUCCESS', payload: response })
        } else {
          throw new Error('empty response')
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: 'FETCH_FAILURE', payload: error })
        }
      }
    }
    if (apiFunction) {
      fetchData()
    }
    return () => {
      didCancel = true
    }
  }, [queryData, apiFunction])

  return [state, setApiArguments]
}

export default useApiHelper
